/**
 * 前端城市工具函数
 * 提供城市代码和名称之间的转换
 * 使用 GB/T 2260 国家标准代码（6位数字代码）
 */

// 城市代码到名称的映射（GB/T 2260 标准）
const CITY_CODE_TO_NAME = {
	"110000": "北京",
	"120000": "天津",
	"130100": "石家庄",
	"130200": "唐山",
	"130300": "秦皇岛",
	"130400": "邯郸",
	"130500": "邢台",
	"130600": "保定",
	"130700": "张家口",
	"130800": "承德",
	"130900": "沧州",
	"131000": "廊坊",
	"131100": "衡水",
	"140100": "太原",
	"140200": "大同",
	"140300": "阳泉",
	"140400": "长治",
	"140500": "晋城",
	"140600": "朔州",
	"140700": "晋中",
	"140800": "运城",
	"140900": "忻州",
	"141000": "临汾",
	"141100": "吕梁",
	"150100": "呼和浩特",
	"150200": "包头",
	"150300": "乌海",
	"150400": "赤峰",
	"150500": "通辽",
	"150600": "鄂尔多斯",
	"150700": "呼伦贝尔",
	"150800": "巴彦淖尔",
	"150900": "乌兰察布",
	"210100": "沈阳",
	"210200": "大连",
	"210300": "鞍山",
	"210400": "抚顺",
	"210500": "本溪",
	"210600": "丹东",
	"210700": "锦州",
	"210800": "营口",
	"210900": "阜新",
	"211000": "辽阳",
	"211100": "盘锦",
	"211200": "铁岭",
	"211300": "朝阳",
	"211400": "葫芦岛",
	"220100": "长春",
	"220200": "吉林",
	"220300": "四平",
	"220400": "辽源",
	"220500": "通化",
	"220600": "白山",
	"220700": "松原",
	"220800": "白城",
	"230100": "哈尔滨",
	"230200": "齐齐哈尔",
	"230300": "鸡西",
	"230400": "鹤岗",
	"230500": "双鸭山",
	"230600": "大庆",
	"230700": "伊春",
	"230800": "佳木斯",
	"230900": "七台河",
	"231000": "牡丹江",
	"231100": "黑河",
	"231200": "绥化",
	"310000": "上海",
	"320100": "南京",
	"320200": "无锡",
	"320300": "徐州",
	"320400": "常州",
	"320500": "苏州",
	"320600": "南通",
	"320700": "连云港",
	"320800": "淮安",
	"320900": "盐城",
	"321000": "扬州",
	"321100": "镇江",
	"321200": "泰州",
	"321300": "宿迁",
	"330100": "杭州",
	"330200": "宁波",
	"330300": "温州",
	"330400": "嘉兴",
	"330500": "湖州",
	"330600": "绍兴",
	"330700": "金华",
	"330800": "衢州",
	"330900": "舟山",
	"331000": "台州",
	"331100": "丽水",
	"340100": "合肥",
	"340200": "芜湖",
	"340300": "蚌埠",
	"340400": "淮南",
	"340500": "马鞍山",
	"340600": "淮北",
	"340700": "铜陵",
	"340800": "安庆",
	"341000": "黄山",
	"341100": "滁州",
	"341200": "阜阳",
	"341300": "宿州",
	"341500": "六安",
	"341600": "亳州",
	"341700": "池州",
	"341800": "宣城",
	"350100": "福州",
	"350200": "厦门",
	"350300": "莆田",
	"350400": "三明",
	"350500": "泉州",
	"350600": "漳州",
	"350700": "南平",
	"350800": "龙岩",
	"350900": "宁德",
	"360100": "南昌",
	"360200": "景德镇",
	"360300": "萍乡",
	"360400": "九江",
	"360500": "新余",
	"360600": "鹰潭",
	"360700": "赣州",
	"360800": "吉安",
	"360900": "宜春",
	"361000": "抚州",
	"361100": "上饶",
	"370100": "济南",
	"370200": "青岛",
	"370300": "淄博",
	"370400": "枣庄",
	"370500": "东营",
	"370600": "烟台",
	"370700": "潍坊",
	"370800": "济宁",
	"370900": "泰安",
	"371000": "威海",
	"371100": "日照",
	"371300": "临沂",
	"371400": "德州",
	"371500": "聊城",
	"371600": "滨州",
	"371700": "菏泽",
	"410100": "郑州",
	"410200": "开封",
	"410300": "洛阳",
	"410400": "平顶山",
	"410500": "安阳",
	"410600": "鹤壁",
	"410700": "新乡",
	"410800": "焦作",
	"410900": "濮阳",
	"411000": "许昌",
	"411100": "漯河",
	"411200": "三门峡",
	"411300": "南阳",
	"411400": "商丘",
	"411500": "信阳",
	"411600": "周口",
	"411700": "驻马店",
	"420100": "武汉",
	"420200": "黄石",
	"420300": "十堰",
	"420500": "宜昌",
	"420600": "襄阳",
	"420700": "鄂州",
	"420800": "荆门",
	"420900": "孝感",
	"421000": "荆州",
	"421100": "黄冈",
	"421200": "咸宁",
	"421300": "随州",
	"430100": "长沙",
	"430200": "株洲",
	"430300": "湘潭",
	"430400": "衡阳",
	"430500": "邵阳",
	"430600": "岳阳",
	"430700": "常德",
	"430800": "张家界",
	"430900": "益阳",
	"431000": "郴州",
	"431100": "永州",
	"431200": "怀化",
	"431300": "娄底",
	"440100": "广州",
	"440200": "韶关",
	"440300": "深圳",
	"440400": "珠海",
	"440500": "汕头",
	"440600": "佛山",
	"440700": "江门",
	"440800": "湛江",
	"440900": "茂名",
	"441200": "肇庆",
	"441300": "惠州",
	"441400": "梅州",
	"441500": "汕尾",
	"441600": "河源",
	"441700": "阳江",
	"441800": "清远",
	"441900": "东莞",
	"442000": "中山",
	"445100": "潮州",
	"445200": "揭阳",
	"445300": "云浮",
	"450100": "南宁",
	"450200": "柳州",
	"450300": "桂林",
	"450400": "梧州",
	"450500": "北海",
	"450600": "防城港",
	"450700": "钦州",
	"450800": "贵港",
	"450900": "玉林",
	"451000": "百色",
	"451100": "贺州",
	"451200": "河池",
	"451300": "来宾",
	"451400": "崇左",
	"460100": "海口",
	"460200": "三亚",
	"460300": "三沙",
	"460400": "儋州",
	"500000": "重庆",
	"510100": "成都",
	"510300": "自贡",
	"510400": "攀枝花",
	"510500": "泸州",
	"510600": "德阳",
	"510700": "绵阳",
	"510800": "广元",
	"510900": "遂宁",
	"511000": "内江",
	"511100": "乐山",
	"511300": "南充",
	"511400": "眉山",
	"511500": "宜宾",
	"511600": "广安",
	"511700": "达州",
	"511800": "雅安",
	"511900": "巴中",
	"512000": "资阳",
	"520100": "贵阳",
	"520200": "六盘水",
	"520300": "遵义",
	"520400": "安顺",
	"520500": "毕节",
	"520600": "铜仁",
	"530100": "昆明",
	"530300": "曲靖",
	"530400": "玉溪",
	"530500": "保山",
	"530600": "昭通",
	"530700": "丽江",
	"530800": "普洱",
	"530900": "临沧",
	"540100": "拉萨",
	"540200": "日喀则",
	"540300": "昌都",
	"540400": "林芝",
	"540500": "山南",
	"540600": "那曲",
	"610100": "西安",
	"610200": "铜川",
	"610300": "宝鸡",
	"610400": "咸阳",
	"610500": "渭南",
	"610600": "延安",
	"610700": "汉中",
	"610800": "榆林",
	"610900": "安康",
	"611000": "商洛",
	"620100": "兰州",
	"620200": "嘉峪关",
	"620300": "金昌",
	"620400": "白银",
	"620500": "天水",
	"620600": "武威",
	"620700": "张掖",
	"620800": "平凉",
	"620900": "酒泉",
	"621000": "庆阳",
	"621100": "定西",
	"621200": "陇南",
	"630100": "西宁",
	"630200": "海东",
	"640100": "银川",
	"640200": "石嘴山",
	"640300": "吴忠",
	"640400": "固原",
	"640500": "中卫",
	"650100": "乌鲁木齐",
	"650200": "克拉玛依",
	"650400": "吐鲁番",
	"650500": "哈密"
};

// 城市代码到完整信息的映射
const CITY_CODE_TO_INFO = {
	"110000": {
		"code": "110000",
		"name": "北京",
		"provinceCode": "110000",
		"provinceName": "北京"
	},
	"120000": {
		"code": "120000",
		"name": "天津",
		"provinceCode": "120000",
		"provinceName": "天津"
	},
	"130100": {
		"code": "130100",
		"name": "石家庄",
		"provinceCode": "130000",
		"provinceName": "河北"
	},
	"130200": {
		"code": "130200",
		"name": "唐山",
		"provinceCode": "130000",
		"provinceName": "河北"
	},
	"130300": {
		"code": "130300",
		"name": "秦皇岛",
		"provinceCode": "130000",
		"provinceName": "河北"
	},
	"130400": {
		"code": "130400",
		"name": "邯郸",
		"provinceCode": "130000",
		"provinceName": "河北"
	},
	"130500": {
		"code": "130500",
		"name": "邢台",
		"provinceCode": "130000",
		"provinceName": "河北"
	},
	"130600": {
		"code": "130600",
		"name": "保定",
		"provinceCode": "130000",
		"provinceName": "河北"
	},
	"130700": {
		"code": "130700",
		"name": "张家口",
		"provinceCode": "130000",
		"provinceName": "河北"
	},
	"130800": {
		"code": "130800",
		"name": "承德",
		"provinceCode": "130000",
		"provinceName": "河北"
	},
	"130900": {
		"code": "130900",
		"name": "沧州",
		"provinceCode": "130000",
		"provinceName": "河北"
	},
	"131000": {
		"code": "131000",
		"name": "廊坊",
		"provinceCode": "130000",
		"provinceName": "河北"
	},
	"131100": {
		"code": "131100",
		"name": "衡水",
		"provinceCode": "130000",
		"provinceName": "河北"
	},
	"140100": {
		"code": "140100",
		"name": "太原",
		"provinceCode": "140000",
		"provinceName": "山西"
	},
	"140200": {
		"code": "140200",
		"name": "大同",
		"provinceCode": "140000",
		"provinceName": "山西"
	},
	"140300": {
		"code": "140300",
		"name": "阳泉",
		"provinceCode": "140000",
		"provinceName": "山西"
	},
	"140400": {
		"code": "140400",
		"name": "长治",
		"provinceCode": "140000",
		"provinceName": "山西"
	},
	"140500": {
		"code": "140500",
		"name": "晋城",
		"provinceCode": "140000",
		"provinceName": "山西"
	},
	"140600": {
		"code": "140600",
		"name": "朔州",
		"provinceCode": "140000",
		"provinceName": "山西"
	},
	"140700": {
		"code": "140700",
		"name": "晋中",
		"provinceCode": "140000",
		"provinceName": "山西"
	},
	"140800": {
		"code": "140800",
		"name": "运城",
		"provinceCode": "140000",
		"provinceName": "山西"
	},
	"140900": {
		"code": "140900",
		"name": "忻州",
		"provinceCode": "140000",
		"provinceName": "山西"
	},
	"141000": {
		"code": "141000",
		"name": "临汾",
		"provinceCode": "140000",
		"provinceName": "山西"
	},
	"141100": {
		"code": "141100",
		"name": "吕梁",
		"provinceCode": "140000",
		"provinceName": "山西"
	},
	"150100": {
		"code": "150100",
		"name": "呼和浩特",
		"provinceCode": "150000",
		"provinceName": "内蒙古"
	},
	"150200": {
		"code": "150200",
		"name": "包头",
		"provinceCode": "150000",
		"provinceName": "内蒙古"
	},
	"150300": {
		"code": "150300",
		"name": "乌海",
		"provinceCode": "150000",
		"provinceName": "内蒙古"
	},
	"150400": {
		"code": "150400",
		"name": "赤峰",
		"provinceCode": "150000",
		"provinceName": "内蒙古"
	},
	"150500": {
		"code": "150500",
		"name": "通辽",
		"provinceCode": "150000",
		"provinceName": "内蒙古"
	},
	"150600": {
		"code": "150600",
		"name": "鄂尔多斯",
		"provinceCode": "150000",
		"provinceName": "内蒙古"
	},
	"150700": {
		"code": "150700",
		"name": "呼伦贝尔",
		"provinceCode": "150000",
		"provinceName": "内蒙古"
	},
	"150800": {
		"code": "150800",
		"name": "巴彦淖尔",
		"provinceCode": "150000",
		"provinceName": "内蒙古"
	},
	"150900": {
		"code": "150900",
		"name": "乌兰察布",
		"provinceCode": "150000",
		"provinceName": "内蒙古"
	},
	"210100": {
		"code": "210100",
		"name": "沈阳",
		"provinceCode": "210000",
		"provinceName": "辽宁"
	},
	"210200": {
		"code": "210200",
		"name": "大连",
		"provinceCode": "210000",
		"provinceName": "辽宁"
	},
	"210300": {
		"code": "210300",
		"name": "鞍山",
		"provinceCode": "210000",
		"provinceName": "辽宁"
	},
	"210400": {
		"code": "210400",
		"name": "抚顺",
		"provinceCode": "210000",
		"provinceName": "辽宁"
	},
	"210500": {
		"code": "210500",
		"name": "本溪",
		"provinceCode": "210000",
		"provinceName": "辽宁"
	},
	"210600": {
		"code": "210600",
		"name": "丹东",
		"provinceCode": "210000",
		"provinceName": "辽宁"
	},
	"210700": {
		"code": "210700",
		"name": "锦州",
		"provinceCode": "210000",
		"provinceName": "辽宁"
	},
	"210800": {
		"code": "210800",
		"name": "营口",
		"provinceCode": "210000",
		"provinceName": "辽宁"
	},
	"210900": {
		"code": "210900",
		"name": "阜新",
		"provinceCode": "210000",
		"provinceName": "辽宁"
	},
	"211000": {
		"code": "211000",
		"name": "辽阳",
		"provinceCode": "210000",
		"provinceName": "辽宁"
	},
	"211100": {
		"code": "211100",
		"name": "盘锦",
		"provinceCode": "210000",
		"provinceName": "辽宁"
	},
	"211200": {
		"code": "211200",
		"name": "铁岭",
		"provinceCode": "210000",
		"provinceName": "辽宁"
	},
	"211300": {
		"code": "211300",
		"name": "朝阳",
		"provinceCode": "210000",
		"provinceName": "辽宁"
	},
	"211400": {
		"code": "211400",
		"name": "葫芦岛",
		"provinceCode": "210000",
		"provinceName": "辽宁"
	},
	"220100": {
		"code": "220100",
		"name": "长春",
		"provinceCode": "220000",
		"provinceName": "吉林"
	},
	"220200": {
		"code": "220200",
		"name": "吉林",
		"provinceCode": "220000",
		"provinceName": "吉林"
	},
	"220300": {
		"code": "220300",
		"name": "四平",
		"provinceCode": "220000",
		"provinceName": "吉林"
	},
	"220400": {
		"code": "220400",
		"name": "辽源",
		"provinceCode": "220000",
		"provinceName": "吉林"
	},
	"220500": {
		"code": "220500",
		"name": "通化",
		"provinceCode": "220000",
		"provinceName": "吉林"
	},
	"220600": {
		"code": "220600",
		"name": "白山",
		"provinceCode": "220000",
		"provinceName": "吉林"
	},
	"220700": {
		"code": "220700",
		"name": "松原",
		"provinceCode": "220000",
		"provinceName": "吉林"
	},
	"220800": {
		"code": "220800",
		"name": "白城",
		"provinceCode": "220000",
		"provinceName": "吉林"
	},
	"230100": {
		"code": "230100",
		"name": "哈尔滨",
		"provinceCode": "230000",
		"provinceName": "黑龙江"
	},
	"230200": {
		"code": "230200",
		"name": "齐齐哈尔",
		"provinceCode": "230000",
		"provinceName": "黑龙江"
	},
	"230300": {
		"code": "230300",
		"name": "鸡西",
		"provinceCode": "230000",
		"provinceName": "黑龙江"
	},
	"230400": {
		"code": "230400",
		"name": "鹤岗",
		"provinceCode": "230000",
		"provinceName": "黑龙江"
	},
	"230500": {
		"code": "230500",
		"name": "双鸭山",
		"provinceCode": "230000",
		"provinceName": "黑龙江"
	},
	"230600": {
		"code": "230600",
		"name": "大庆",
		"provinceCode": "230000",
		"provinceName": "黑龙江"
	},
	"230700": {
		"code": "230700",
		"name": "伊春",
		"provinceCode": "230000",
		"provinceName": "黑龙江"
	},
	"230800": {
		"code": "230800",
		"name": "佳木斯",
		"provinceCode": "230000",
		"provinceName": "黑龙江"
	},
	"230900": {
		"code": "230900",
		"name": "七台河",
		"provinceCode": "230000",
		"provinceName": "黑龙江"
	},
	"231000": {
		"code": "231000",
		"name": "牡丹江",
		"provinceCode": "230000",
		"provinceName": "黑龙江"
	},
	"231100": {
		"code": "231100",
		"name": "黑河",
		"provinceCode": "230000",
		"provinceName": "黑龙江"
	},
	"231200": {
		"code": "231200",
		"name": "绥化",
		"provinceCode": "230000",
		"provinceName": "黑龙江"
	},
	"310000": {
		"code": "310000",
		"name": "上海",
		"provinceCode": "310000",
		"provinceName": "上海"
	},
	"320100": {
		"code": "320100",
		"name": "南京",
		"provinceCode": "320000",
		"provinceName": "江苏"
	},
	"320200": {
		"code": "320200",
		"name": "无锡",
		"provinceCode": "320000",
		"provinceName": "江苏"
	},
	"320300": {
		"code": "320300",
		"name": "徐州",
		"provinceCode": "320000",
		"provinceName": "江苏"
	},
	"320400": {
		"code": "320400",
		"name": "常州",
		"provinceCode": "320000",
		"provinceName": "江苏"
	},
	"320500": {
		"code": "320500",
		"name": "苏州",
		"provinceCode": "320000",
		"provinceName": "江苏"
	},
	"320600": {
		"code": "320600",
		"name": "南通",
		"provinceCode": "320000",
		"provinceName": "江苏"
	},
	"320700": {
		"code": "320700",
		"name": "连云港",
		"provinceCode": "320000",
		"provinceName": "江苏"
	},
	"320800": {
		"code": "320800",
		"name": "淮安",
		"provinceCode": "320000",
		"provinceName": "江苏"
	},
	"320900": {
		"code": "320900",
		"name": "盐城",
		"provinceCode": "320000",
		"provinceName": "江苏"
	},
	"321000": {
		"code": "321000",
		"name": "扬州",
		"provinceCode": "320000",
		"provinceName": "江苏"
	},
	"321100": {
		"code": "321100",
		"name": "镇江",
		"provinceCode": "320000",
		"provinceName": "江苏"
	},
	"321200": {
		"code": "321200",
		"name": "泰州",
		"provinceCode": "320000",
		"provinceName": "江苏"
	},
	"321300": {
		"code": "321300",
		"name": "宿迁",
		"provinceCode": "320000",
		"provinceName": "江苏"
	},
	"330100": {
		"code": "330100",
		"name": "杭州",
		"provinceCode": "330000",
		"provinceName": "浙江"
	},
	"330200": {
		"code": "330200",
		"name": "宁波",
		"provinceCode": "330000",
		"provinceName": "浙江"
	},
	"330300": {
		"code": "330300",
		"name": "温州",
		"provinceCode": "330000",
		"provinceName": "浙江"
	},
	"330400": {
		"code": "330400",
		"name": "嘉兴",
		"provinceCode": "330000",
		"provinceName": "浙江"
	},
	"330500": {
		"code": "330500",
		"name": "湖州",
		"provinceCode": "330000",
		"provinceName": "浙江"
	},
	"330600": {
		"code": "330600",
		"name": "绍兴",
		"provinceCode": "330000",
		"provinceName": "浙江"
	},
	"330700": {
		"code": "330700",
		"name": "金华",
		"provinceCode": "330000",
		"provinceName": "浙江"
	},
	"330800": {
		"code": "330800",
		"name": "衢州",
		"provinceCode": "330000",
		"provinceName": "浙江"
	},
	"330900": {
		"code": "330900",
		"name": "舟山",
		"provinceCode": "330000",
		"provinceName": "浙江"
	},
	"331000": {
		"code": "331000",
		"name": "台州",
		"provinceCode": "330000",
		"provinceName": "浙江"
	},
	"331100": {
		"code": "331100",
		"name": "丽水",
		"provinceCode": "330000",
		"provinceName": "浙江"
	},
	"340100": {
		"code": "340100",
		"name": "合肥",
		"provinceCode": "340000",
		"provinceName": "安徽"
	},
	"340200": {
		"code": "340200",
		"name": "芜湖",
		"provinceCode": "340000",
		"provinceName": "安徽"
	},
	"340300": {
		"code": "340300",
		"name": "蚌埠",
		"provinceCode": "340000",
		"provinceName": "安徽"
	},
	"340400": {
		"code": "340400",
		"name": "淮南",
		"provinceCode": "340000",
		"provinceName": "安徽"
	},
	"340500": {
		"code": "340500",
		"name": "马鞍山",
		"provinceCode": "340000",
		"provinceName": "安徽"
	},
	"340600": {
		"code": "340600",
		"name": "淮北",
		"provinceCode": "340000",
		"provinceName": "安徽"
	},
	"340700": {
		"code": "340700",
		"name": "铜陵",
		"provinceCode": "340000",
		"provinceName": "安徽"
	},
	"340800": {
		"code": "340800",
		"name": "安庆",
		"provinceCode": "340000",
		"provinceName": "安徽"
	},
	"341000": {
		"code": "341000",
		"name": "黄山",
		"provinceCode": "340000",
		"provinceName": "安徽"
	},
	"341100": {
		"code": "341100",
		"name": "滁州",
		"provinceCode": "340000",
		"provinceName": "安徽"
	},
	"341200": {
		"code": "341200",
		"name": "阜阳",
		"provinceCode": "340000",
		"provinceName": "安徽"
	},
	"341300": {
		"code": "341300",
		"name": "宿州",
		"provinceCode": "340000",
		"provinceName": "安徽"
	},
	"341500": {
		"code": "341500",
		"name": "六安",
		"provinceCode": "340000",
		"provinceName": "安徽"
	},
	"341600": {
		"code": "341600",
		"name": "亳州",
		"provinceCode": "340000",
		"provinceName": "安徽"
	},
	"341700": {
		"code": "341700",
		"name": "池州",
		"provinceCode": "340000",
		"provinceName": "安徽"
	},
	"341800": {
		"code": "341800",
		"name": "宣城",
		"provinceCode": "340000",
		"provinceName": "安徽"
	},
	"350100": {
		"code": "350100",
		"name": "福州",
		"provinceCode": "350000",
		"provinceName": "福建"
	},
	"350200": {
		"code": "350200",
		"name": "厦门",
		"provinceCode": "350000",
		"provinceName": "福建"
	},
	"350300": {
		"code": "350300",
		"name": "莆田",
		"provinceCode": "350000",
		"provinceName": "福建"
	},
	"350400": {
		"code": "350400",
		"name": "三明",
		"provinceCode": "350000",
		"provinceName": "福建"
	},
	"350500": {
		"code": "350500",
		"name": "泉州",
		"provinceCode": "350000",
		"provinceName": "福建"
	},
	"350600": {
		"code": "350600",
		"name": "漳州",
		"provinceCode": "350000",
		"provinceName": "福建"
	},
	"350700": {
		"code": "350700",
		"name": "南平",
		"provinceCode": "350000",
		"provinceName": "福建"
	},
	"350800": {
		"code": "350800",
		"name": "龙岩",
		"provinceCode": "350000",
		"provinceName": "福建"
	},
	"350900": {
		"code": "350900",
		"name": "宁德",
		"provinceCode": "350000",
		"provinceName": "福建"
	},
	"360100": {
		"code": "360100",
		"name": "南昌",
		"provinceCode": "360000",
		"provinceName": "江西"
	},
	"360200": {
		"code": "360200",
		"name": "景德镇",
		"provinceCode": "360000",
		"provinceName": "江西"
	},
	"360300": {
		"code": "360300",
		"name": "萍乡",
		"provinceCode": "360000",
		"provinceName": "江西"
	},
	"360400": {
		"code": "360400",
		"name": "九江",
		"provinceCode": "360000",
		"provinceName": "江西"
	},
	"360500": {
		"code": "360500",
		"name": "新余",
		"provinceCode": "360000",
		"provinceName": "江西"
	},
	"360600": {
		"code": "360600",
		"name": "鹰潭",
		"provinceCode": "360000",
		"provinceName": "江西"
	},
	"360700": {
		"code": "360700",
		"name": "赣州",
		"provinceCode": "360000",
		"provinceName": "江西"
	},
	"360800": {
		"code": "360800",
		"name": "吉安",
		"provinceCode": "360000",
		"provinceName": "江西"
	},
	"360900": {
		"code": "360900",
		"name": "宜春",
		"provinceCode": "360000",
		"provinceName": "江西"
	},
	"361000": {
		"code": "361000",
		"name": "抚州",
		"provinceCode": "360000",
		"provinceName": "江西"
	},
	"361100": {
		"code": "361100",
		"name": "上饶",
		"provinceCode": "360000",
		"provinceName": "江西"
	},
	"370100": {
		"code": "370100",
		"name": "济南",
		"provinceCode": "370000",
		"provinceName": "山东"
	},
	"370200": {
		"code": "370200",
		"name": "青岛",
		"provinceCode": "370000",
		"provinceName": "山东"
	},
	"370300": {
		"code": "370300",
		"name": "淄博",
		"provinceCode": "370000",
		"provinceName": "山东"
	},
	"370400": {
		"code": "370400",
		"name": "枣庄",
		"provinceCode": "370000",
		"provinceName": "山东"
	},
	"370500": {
		"code": "370500",
		"name": "东营",
		"provinceCode": "370000",
		"provinceName": "山东"
	},
	"370600": {
		"code": "370600",
		"name": "烟台",
		"provinceCode": "370000",
		"provinceName": "山东"
	},
	"370700": {
		"code": "370700",
		"name": "潍坊",
		"provinceCode": "370000",
		"provinceName": "山东"
	},
	"370800": {
		"code": "370800",
		"name": "济宁",
		"provinceCode": "370000",
		"provinceName": "山东"
	},
	"370900": {
		"code": "370900",
		"name": "泰安",
		"provinceCode": "370000",
		"provinceName": "山东"
	},
	"371000": {
		"code": "371000",
		"name": "威海",
		"provinceCode": "370000",
		"provinceName": "山东"
	},
	"371100": {
		"code": "371100",
		"name": "日照",
		"provinceCode": "370000",
		"provinceName": "山东"
	},
	"371300": {
		"code": "371300",
		"name": "临沂",
		"provinceCode": "370000",
		"provinceName": "山东"
	},
	"371400": {
		"code": "371400",
		"name": "德州",
		"provinceCode": "370000",
		"provinceName": "山东"
	},
	"371500": {
		"code": "371500",
		"name": "聊城",
		"provinceCode": "370000",
		"provinceName": "山东"
	},
	"371600": {
		"code": "371600",
		"name": "滨州",
		"provinceCode": "370000",
		"provinceName": "山东"
	},
	"371700": {
		"code": "371700",
		"name": "菏泽",
		"provinceCode": "370000",
		"provinceName": "山东"
	},
	"410100": {
		"code": "410100",
		"name": "郑州",
		"provinceCode": "410000",
		"provinceName": "河南"
	},
	"410200": {
		"code": "410200",
		"name": "开封",
		"provinceCode": "410000",
		"provinceName": "河南"
	},
	"410300": {
		"code": "410300",
		"name": "洛阳",
		"provinceCode": "410000",
		"provinceName": "河南"
	},
	"410400": {
		"code": "410400",
		"name": "平顶山",
		"provinceCode": "410000",
		"provinceName": "河南"
	},
	"410500": {
		"code": "410500",
		"name": "安阳",
		"provinceCode": "410000",
		"provinceName": "河南"
	},
	"410600": {
		"code": "410600",
		"name": "鹤壁",
		"provinceCode": "410000",
		"provinceName": "河南"
	},
	"410700": {
		"code": "410700",
		"name": "新乡",
		"provinceCode": "410000",
		"provinceName": "河南"
	},
	"410800": {
		"code": "410800",
		"name": "焦作",
		"provinceCode": "410000",
		"provinceName": "河南"
	},
	"410900": {
		"code": "410900",
		"name": "濮阳",
		"provinceCode": "410000",
		"provinceName": "河南"
	},
	"411000": {
		"code": "411000",
		"name": "许昌",
		"provinceCode": "410000",
		"provinceName": "河南"
	},
	"411100": {
		"code": "411100",
		"name": "漯河",
		"provinceCode": "410000",
		"provinceName": "河南"
	},
	"411200": {
		"code": "411200",
		"name": "三门峡",
		"provinceCode": "410000",
		"provinceName": "河南"
	},
	"411300": {
		"code": "411300",
		"name": "南阳",
		"provinceCode": "410000",
		"provinceName": "河南"
	},
	"411400": {
		"code": "411400",
		"name": "商丘",
		"provinceCode": "410000",
		"provinceName": "河南"
	},
	"411500": {
		"code": "411500",
		"name": "信阳",
		"provinceCode": "410000",
		"provinceName": "河南"
	},
	"411600": {
		"code": "411600",
		"name": "周口",
		"provinceCode": "410000",
		"provinceName": "河南"
	},
	"411700": {
		"code": "411700",
		"name": "驻马店",
		"provinceCode": "410000",
		"provinceName": "河南"
	},
	"420100": {
		"code": "420100",
		"name": "武汉",
		"provinceCode": "420000",
		"provinceName": "湖北"
	},
	"420200": {
		"code": "420200",
		"name": "黄石",
		"provinceCode": "420000",
		"provinceName": "湖北"
	},
	"420300": {
		"code": "420300",
		"name": "十堰",
		"provinceCode": "420000",
		"provinceName": "湖北"
	},
	"420500": {
		"code": "420500",
		"name": "宜昌",
		"provinceCode": "420000",
		"provinceName": "湖北"
	},
	"420600": {
		"code": "420600",
		"name": "襄阳",
		"provinceCode": "420000",
		"provinceName": "湖北"
	},
	"420700": {
		"code": "420700",
		"name": "鄂州",
		"provinceCode": "420000",
		"provinceName": "湖北"
	},
	"420800": {
		"code": "420800",
		"name": "荆门",
		"provinceCode": "420000",
		"provinceName": "湖北"
	},
	"420900": {
		"code": "420900",
		"name": "孝感",
		"provinceCode": "420000",
		"provinceName": "湖北"
	},
	"421000": {
		"code": "421000",
		"name": "荆州",
		"provinceCode": "420000",
		"provinceName": "湖北"
	},
	"421100": {
		"code": "421100",
		"name": "黄冈",
		"provinceCode": "420000",
		"provinceName": "湖北"
	},
	"421200": {
		"code": "421200",
		"name": "咸宁",
		"provinceCode": "420000",
		"provinceName": "湖北"
	},
	"421300": {
		"code": "421300",
		"name": "随州",
		"provinceCode": "420000",
		"provinceName": "湖北"
	},
	"430100": {
		"code": "430100",
		"name": "长沙",
		"provinceCode": "430000",
		"provinceName": "湖南"
	},
	"430200": {
		"code": "430200",
		"name": "株洲",
		"provinceCode": "430000",
		"provinceName": "湖南"
	},
	"430300": {
		"code": "430300",
		"name": "湘潭",
		"provinceCode": "430000",
		"provinceName": "湖南"
	},
	"430400": {
		"code": "430400",
		"name": "衡阳",
		"provinceCode": "430000",
		"provinceName": "湖南"
	},
	"430500": {
		"code": "430500",
		"name": "邵阳",
		"provinceCode": "430000",
		"provinceName": "湖南"
	},
	"430600": {
		"code": "430600",
		"name": "岳阳",
		"provinceCode": "430000",
		"provinceName": "湖南"
	},
	"430700": {
		"code": "430700",
		"name": "常德",
		"provinceCode": "430000",
		"provinceName": "湖南"
	},
	"430800": {
		"code": "430800",
		"name": "张家界",
		"provinceCode": "430000",
		"provinceName": "湖南"
	},
	"430900": {
		"code": "430900",
		"name": "益阳",
		"provinceCode": "430000",
		"provinceName": "湖南"
	},
	"431000": {
		"code": "431000",
		"name": "郴州",
		"provinceCode": "430000",
		"provinceName": "湖南"
	},
	"431100": {
		"code": "431100",
		"name": "永州",
		"provinceCode": "430000",
		"provinceName": "湖南"
	},
	"431200": {
		"code": "431200",
		"name": "怀化",
		"provinceCode": "430000",
		"provinceName": "湖南"
	},
	"431300": {
		"code": "431300",
		"name": "娄底",
		"provinceCode": "430000",
		"provinceName": "湖南"
	},
	"440100": {
		"code": "440100",
		"name": "广州",
		"provinceCode": "440000",
		"provinceName": "广东"
	},
	"440200": {
		"code": "440200",
		"name": "韶关",
		"provinceCode": "440000",
		"provinceName": "广东"
	},
	"440300": {
		"code": "440300",
		"name": "深圳",
		"provinceCode": "440000",
		"provinceName": "广东"
	},
	"440400": {
		"code": "440400",
		"name": "珠海",
		"provinceCode": "440000",
		"provinceName": "广东"
	},
	"440500": {
		"code": "440500",
		"name": "汕头",
		"provinceCode": "440000",
		"provinceName": "广东"
	},
	"440600": {
		"code": "440600",
		"name": "佛山",
		"provinceCode": "440000",
		"provinceName": "广东"
	},
	"440700": {
		"code": "440700",
		"name": "江门",
		"provinceCode": "440000",
		"provinceName": "广东"
	},
	"440800": {
		"code": "440800",
		"name": "湛江",
		"provinceCode": "440000",
		"provinceName": "广东"
	},
	"440900": {
		"code": "440900",
		"name": "茂名",
		"provinceCode": "440000",
		"provinceName": "广东"
	},
	"441200": {
		"code": "441200",
		"name": "肇庆",
		"provinceCode": "440000",
		"provinceName": "广东"
	},
	"441300": {
		"code": "441300",
		"name": "惠州",
		"provinceCode": "440000",
		"provinceName": "广东"
	},
	"441400": {
		"code": "441400",
		"name": "梅州",
		"provinceCode": "440000",
		"provinceName": "广东"
	},
	"441500": {
		"code": "441500",
		"name": "汕尾",
		"provinceCode": "440000",
		"provinceName": "广东"
	},
	"441600": {
		"code": "441600",
		"name": "河源",
		"provinceCode": "440000",
		"provinceName": "广东"
	},
	"441700": {
		"code": "441700",
		"name": "阳江",
		"provinceCode": "440000",
		"provinceName": "广东"
	},
	"441800": {
		"code": "441800",
		"name": "清远",
		"provinceCode": "440000",
		"provinceName": "广东"
	},
	"441900": {
		"code": "441900",
		"name": "东莞",
		"provinceCode": "440000",
		"provinceName": "广东"
	},
	"442000": {
		"code": "442000",
		"name": "中山",
		"provinceCode": "440000",
		"provinceName": "广东"
	},
	"445100": {
		"code": "445100",
		"name": "潮州",
		"provinceCode": "440000",
		"provinceName": "广东"
	},
	"445200": {
		"code": "445200",
		"name": "揭阳",
		"provinceCode": "440000",
		"provinceName": "广东"
	},
	"445300": {
		"code": "445300",
		"name": "云浮",
		"provinceCode": "440000",
		"provinceName": "广东"
	},
	"450100": {
		"code": "450100",
		"name": "南宁",
		"provinceCode": "450000",
		"provinceName": "广西"
	},
	"450200": {
		"code": "450200",
		"name": "柳州",
		"provinceCode": "450000",
		"provinceName": "广西"
	},
	"450300": {
		"code": "450300",
		"name": "桂林",
		"provinceCode": "450000",
		"provinceName": "广西"
	},
	"450400": {
		"code": "450400",
		"name": "梧州",
		"provinceCode": "450000",
		"provinceName": "广西"
	},
	"450500": {
		"code": "450500",
		"name": "北海",
		"provinceCode": "450000",
		"provinceName": "广西"
	},
	"450600": {
		"code": "450600",
		"name": "防城港",
		"provinceCode": "450000",
		"provinceName": "广西"
	},
	"450700": {
		"code": "450700",
		"name": "钦州",
		"provinceCode": "450000",
		"provinceName": "广西"
	},
	"450800": {
		"code": "450800",
		"name": "贵港",
		"provinceCode": "450000",
		"provinceName": "广西"
	},
	"450900": {
		"code": "450900",
		"name": "玉林",
		"provinceCode": "450000",
		"provinceName": "广西"
	},
	"451000": {
		"code": "451000",
		"name": "百色",
		"provinceCode": "450000",
		"provinceName": "广西"
	},
	"451100": {
		"code": "451100",
		"name": "贺州",
		"provinceCode": "450000",
		"provinceName": "广西"
	},
	"451200": {
		"code": "451200",
		"name": "河池",
		"provinceCode": "450000",
		"provinceName": "广西"
	},
	"451300": {
		"code": "451300",
		"name": "来宾",
		"provinceCode": "450000",
		"provinceName": "广西"
	},
	"451400": {
		"code": "451400",
		"name": "崇左",
		"provinceCode": "450000",
		"provinceName": "广西"
	},
	"460100": {
		"code": "460100",
		"name": "海口",
		"provinceCode": "460000",
		"provinceName": "海南"
	},
	"460200": {
		"code": "460200",
		"name": "三亚",
		"provinceCode": "460000",
		"provinceName": "海南"
	},
	"460300": {
		"code": "460300",
		"name": "三沙",
		"provinceCode": "460000",
		"provinceName": "海南"
	},
	"460400": {
		"code": "460400",
		"name": "儋州",
		"provinceCode": "460000",
		"provinceName": "海南"
	},
	"500000": {
		"code": "500000",
		"name": "重庆",
		"provinceCode": "500000",
		"provinceName": "重庆"
	},
	"510100": {
		"code": "510100",
		"name": "成都",
		"provinceCode": "510000",
		"provinceName": "四川"
	},
	"510300": {
		"code": "510300",
		"name": "自贡",
		"provinceCode": "510000",
		"provinceName": "四川"
	},
	"510400": {
		"code": "510400",
		"name": "攀枝花",
		"provinceCode": "510000",
		"provinceName": "四川"
	},
	"510500": {
		"code": "510500",
		"name": "泸州",
		"provinceCode": "510000",
		"provinceName": "四川"
	},
	"510600": {
		"code": "510600",
		"name": "德阳",
		"provinceCode": "510000",
		"provinceName": "四川"
	},
	"510700": {
		"code": "510700",
		"name": "绵阳",
		"provinceCode": "510000",
		"provinceName": "四川"
	},
	"510800": {
		"code": "510800",
		"name": "广元",
		"provinceCode": "510000",
		"provinceName": "四川"
	},
	"510900": {
		"code": "510900",
		"name": "遂宁",
		"provinceCode": "510000",
		"provinceName": "四川"
	},
	"511000": {
		"code": "511000",
		"name": "内江",
		"provinceCode": "510000",
		"provinceName": "四川"
	},
	"511100": {
		"code": "511100",
		"name": "乐山",
		"provinceCode": "510000",
		"provinceName": "四川"
	},
	"511300": {
		"code": "511300",
		"name": "南充",
		"provinceCode": "510000",
		"provinceName": "四川"
	},
	"511400": {
		"code": "511400",
		"name": "眉山",
		"provinceCode": "510000",
		"provinceName": "四川"
	},
	"511500": {
		"code": "511500",
		"name": "宜宾",
		"provinceCode": "510000",
		"provinceName": "四川"
	},
	"511600": {
		"code": "511600",
		"name": "广安",
		"provinceCode": "510000",
		"provinceName": "四川"
	},
	"511700": {
		"code": "511700",
		"name": "达州",
		"provinceCode": "510000",
		"provinceName": "四川"
	},
	"511800": {
		"code": "511800",
		"name": "雅安",
		"provinceCode": "510000",
		"provinceName": "四川"
	},
	"511900": {
		"code": "511900",
		"name": "巴中",
		"provinceCode": "510000",
		"provinceName": "四川"
	},
	"512000": {
		"code": "512000",
		"name": "资阳",
		"provinceCode": "510000",
		"provinceName": "四川"
	},
	"520100": {
		"code": "520100",
		"name": "贵阳",
		"provinceCode": "520000",
		"provinceName": "贵州"
	},
	"520200": {
		"code": "520200",
		"name": "六盘水",
		"provinceCode": "520000",
		"provinceName": "贵州"
	},
	"520300": {
		"code": "520300",
		"name": "遵义",
		"provinceCode": "520000",
		"provinceName": "贵州"
	},
	"520400": {
		"code": "520400",
		"name": "安顺",
		"provinceCode": "520000",
		"provinceName": "贵州"
	},
	"520500": {
		"code": "520500",
		"name": "毕节",
		"provinceCode": "520000",
		"provinceName": "贵州"
	},
	"520600": {
		"code": "520600",
		"name": "铜仁",
		"provinceCode": "520000",
		"provinceName": "贵州"
	},
	"530100": {
		"code": "530100",
		"name": "昆明",
		"provinceCode": "530000",
		"provinceName": "云南"
	},
	"530300": {
		"code": "530300",
		"name": "曲靖",
		"provinceCode": "530000",
		"provinceName": "云南"
	},
	"530400": {
		"code": "530400",
		"name": "玉溪",
		"provinceCode": "530000",
		"provinceName": "云南"
	},
	"530500": {
		"code": "530500",
		"name": "保山",
		"provinceCode": "530000",
		"provinceName": "云南"
	},
	"530600": {
		"code": "530600",
		"name": "昭通",
		"provinceCode": "530000",
		"provinceName": "云南"
	},
	"530700": {
		"code": "530700",
		"name": "丽江",
		"provinceCode": "530000",
		"provinceName": "云南"
	},
	"530800": {
		"code": "530800",
		"name": "普洱",
		"provinceCode": "530000",
		"provinceName": "云南"
	},
	"530900": {
		"code": "530900",
		"name": "临沧",
		"provinceCode": "530000",
		"provinceName": "云南"
	},
	"540100": {
		"code": "540100",
		"name": "拉萨",
		"provinceCode": "540000",
		"provinceName": "西藏"
	},
	"540200": {
		"code": "540200",
		"name": "日喀则",
		"provinceCode": "540000",
		"provinceName": "西藏"
	},
	"540300": {
		"code": "540300",
		"name": "昌都",
		"provinceCode": "540000",
		"provinceName": "西藏"
	},
	"540400": {
		"code": "540400",
		"name": "林芝",
		"provinceCode": "540000",
		"provinceName": "西藏"
	},
	"540500": {
		"code": "540500",
		"name": "山南",
		"provinceCode": "540000",
		"provinceName": "西藏"
	},
	"540600": {
		"code": "540600",
		"name": "那曲",
		"provinceCode": "540000",
		"provinceName": "西藏"
	},
	"610100": {
		"code": "610100",
		"name": "西安",
		"provinceCode": "610000",
		"provinceName": "陕西"
	},
	"610200": {
		"code": "610200",
		"name": "铜川",
		"provinceCode": "610000",
		"provinceName": "陕西"
	},
	"610300": {
		"code": "610300",
		"name": "宝鸡",
		"provinceCode": "610000",
		"provinceName": "陕西"
	},
	"610400": {
		"code": "610400",
		"name": "咸阳",
		"provinceCode": "610000",
		"provinceName": "陕西"
	},
	"610500": {
		"code": "610500",
		"name": "渭南",
		"provinceCode": "610000",
		"provinceName": "陕西"
	},
	"610600": {
		"code": "610600",
		"name": "延安",
		"provinceCode": "610000",
		"provinceName": "陕西"
	},
	"610700": {
		"code": "610700",
		"name": "汉中",
		"provinceCode": "610000",
		"provinceName": "陕西"
	},
	"610800": {
		"code": "610800",
		"name": "榆林",
		"provinceCode": "610000",
		"provinceName": "陕西"
	},
	"610900": {
		"code": "610900",
		"name": "安康",
		"provinceCode": "610000",
		"provinceName": "陕西"
	},
	"611000": {
		"code": "611000",
		"name": "商洛",
		"provinceCode": "610000",
		"provinceName": "陕西"
	},
	"620100": {
		"code": "620100",
		"name": "兰州",
		"provinceCode": "620000",
		"provinceName": "甘肃"
	},
	"620200": {
		"code": "620200",
		"name": "嘉峪关",
		"provinceCode": "620000",
		"provinceName": "甘肃"
	},
	"620300": {
		"code": "620300",
		"name": "金昌",
		"provinceCode": "620000",
		"provinceName": "甘肃"
	},
	"620400": {
		"code": "620400",
		"name": "白银",
		"provinceCode": "620000",
		"provinceName": "甘肃"
	},
	"620500": {
		"code": "620500",
		"name": "天水",
		"provinceCode": "620000",
		"provinceName": "甘肃"
	},
	"620600": {
		"code": "620600",
		"name": "武威",
		"provinceCode": "620000",
		"provinceName": "甘肃"
	},
	"620700": {
		"code": "620700",
		"name": "张掖",
		"provinceCode": "620000",
		"provinceName": "甘肃"
	},
	"620800": {
		"code": "620800",
		"name": "平凉",
		"provinceCode": "620000",
		"provinceName": "甘肃"
	},
	"620900": {
		"code": "620900",
		"name": "酒泉",
		"provinceCode": "620000",
		"provinceName": "甘肃"
	},
	"621000": {
		"code": "621000",
		"name": "庆阳",
		"provinceCode": "620000",
		"provinceName": "甘肃"
	},
	"621100": {
		"code": "621100",
		"name": "定西",
		"provinceCode": "620000",
		"provinceName": "甘肃"
	},
	"621200": {
		"code": "621200",
		"name": "陇南",
		"provinceCode": "620000",
		"provinceName": "甘肃"
	},
	"630100": {
		"code": "630100",
		"name": "西宁",
		"provinceCode": "630000",
		"provinceName": "青海"
	},
	"630200": {
		"code": "630200",
		"name": "海东",
		"provinceCode": "630000",
		"provinceName": "青海"
	},
	"640100": {
		"code": "640100",
		"name": "银川",
		"provinceCode": "640000",
		"provinceName": "宁夏"
	},
	"640200": {
		"code": "640200",
		"name": "石嘴山",
		"provinceCode": "640000",
		"provinceName": "宁夏"
	},
	"640300": {
		"code": "640300",
		"name": "吴忠",
		"provinceCode": "640000",
		"provinceName": "宁夏"
	},
	"640400": {
		"code": "640400",
		"name": "固原",
		"provinceCode": "640000",
		"provinceName": "宁夏"
	},
	"640500": {
		"code": "640500",
		"name": "中卫",
		"provinceCode": "640000",
		"provinceName": "宁夏"
	},
	"650100": {
		"code": "650100",
		"name": "乌鲁木齐",
		"provinceCode": "650000",
		"provinceName": "新疆"
	},
	"650200": {
		"code": "650200",
		"name": "克拉玛依",
		"provinceCode": "650000",
		"provinceName": "新疆"
	},
	"650400": {
		"code": "650400",
		"name": "吐鲁番",
		"provinceCode": "650000",
		"provinceName": "新疆"
	},
	"650500": {
		"code": "650500",
		"name": "哈密",
		"provinceCode": "650000",
		"provinceName": "新疆"
	}
};

/**
 * 根据城市代码获取城市名称
 * @param {string} code - 城市代码（GB/T 2260标准：6位数字，如 110000, 310000, 440100）
 * @returns {string} 城市名称
 */
export const getCityNameByCode = (code) => {
	if (!code) return '';
	return CITY_CODE_TO_NAME[code] || code;
};

/**
 * 根据城市代码获取完整城市信息
 * @param {string} code - 城市代码（GB/T 2260标准：6位数字）
 * @returns {object} 城市信息对象，包含 code, name, provinceCode, provinceName
 */
export const getCityInfoByCode = (code) => {
	if (!code) return null;
	return CITY_CODE_TO_INFO[code] || null;
};

/**
 * 根据城市名称获取城市代码
 * @param {string} name - 城市名称（支持"上海"或"上海市"格式）
 * @returns {string} 城市代码（GB/T 2260标准：6位数字）
 */
export const getCityCodeByName = (name) => {
	if (!name) return '';

	// 移除可能的"市"后缀
	let normalizedName = name.trim();
	if (normalizedName.endsWith('市') && !['北京市', '上海市', '天津市', '重庆市'].includes(normalizedName)) {
		normalizedName = normalizedName.replace('市', '');
	}

	// 查找匹配的城市代码
	for (const [code, info] of Object.entries(CITY_CODE_TO_INFO)) {
		if (info.name === normalizedName || info.name === name) {
			return code;
		}
	}

	return '';
};

/**
 * 获取省份下的所有城市
 * @param {string} provinceCode - 省份代码（GB/T 2260标准：6位数字）
 * @returns {array} 城市列表
 */
export const getCitiesByProvinceCode = (provinceCode) => {
	if (!provinceCode) return [];

	return Object.values(CITY_CODE_TO_INFO)
		.filter((city) => city.provinceCode === provinceCode)
		.map((city) => ({
			code: city.code,
			name: city.name,
		}));
};

/**
 * 获取所有省份列表
 * @returns {array} 省份列表
 */
export const getAllProvinces = () => {
	const provinces = new Set();
	Object.values(CITY_CODE_TO_INFO).forEach((city) => {
		provinces.add(JSON.stringify({ code: city.provinceCode, name: city.provinceName }));
	});
	return Array.from(provinces).map((p) => JSON.parse(p));
};
